import React, { Component } from "react";
import { Link } from "react-router-dom";
import Logo from "../../assets/logo.png";

export default class Footer extends Component {
  renderLink = (text: string, action: string) => {
    return (
      <li>
        <Link to={action}>
          <p className="text-base underline text-gray-500 hover:text-gray-900">
            {text}
          </p>
        </Link>
      </li>
    );
  };

  render() {
    return (
      <footer
        className="bg-white w-full border-t-2"
        aria-labelledby="footerHeading"
      >
        <h2 id="footerHeading" className="sr-only">
          Footer
        </h2>
        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
          <div className="xl:grid xl:grid-cols-3 xl:gap-8">
            <div className="grid grid-cols-2 gap-8 xl:col-span-2"></div>
            <div className="mt-12 space-y-8 xl:col-span-1 xl:mt-0">
              <div className="flex flex-col items-start">
                <p className="text-sm my-2 font-semibold uppercase">
                  Powered By
                </p>
                <div className="flex flex-wrap items-center">
                  <img className="h-12 mr-2" src={Logo} alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className="mt-12 border-t-2 pt-8">
            <p className="text-base text-gray-400 xl:text-center">
              Copyright © 2021 Malaysian UBI App. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    );
  }
}
